import { Dispatch } from 'redux';
import { DynamicGroupByModel } from 'src/shared/models/dynamic-group-by.model';
import { IntentStatisticsQueryParams } from 'src/shared/models/query-params.model';
import {
  getIntentStatistics as getIntentStatisticsService,
  exportIntentStatistics as exportIntentStatisticsService,
} from '../services/intent-statistics.service';

export const GET_INTENT_STATISTICS_REQUEST = 'intent-statistics/GET_INTENT_STATISTICS_REQUEST';
export const GET_INTENT_STATISTICS_SUCCESS = 'intent-statistics/GET_INTENT_STATISTICS_SUCCESS';
export const GET_INTENT_STATISTICS_ERROR = 'intent-statistics/GET_INTENT_STATISTICS_ERROR';

export const EXPORT_INTENT_STATISTICS_REQUEST =
  'intent-statistics/EXPORT_INTENT_STATISTICS_REQUEST';
export const EXPORT_INTENT_STATISTICS_SUCCESS =
  'intent-statistics/EXPORT_INTENT_STATISTICS_SUCCESS';
export const EXPORT_INTENT_STATISTICS_ERROR = 'intent-statistics/EXPORT_INTENT_STATISTICS_ERROR';

export const getIntentStatistics = (
  applicationId: number,
  queryParams: IntentStatisticsQueryParams,
  filters: DynamicGroupByModel,
) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GET_INTENT_STATISTICS_REQUEST,
    });

    try {
      const payload = await getIntentStatisticsService(applicationId, queryParams, filters);

      dispatch({
        type: GET_INTENT_STATISTICS_SUCCESS,
        payload,
      });
    } catch (error) {
      dispatch({
        type: GET_INTENT_STATISTICS_ERROR,
        error,
      });
      throw error;
    }
  };
};

export const exportIntentStatistics = (
  applicationId: number,
  queryParams: IntentStatisticsQueryParams,
  filters: DynamicGroupByModel,
) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EXPORT_INTENT_STATISTICS_REQUEST,
    });

    try {
      const payload = await exportIntentStatisticsService(applicationId, queryParams, filters);

      dispatch({
        type: EXPORT_INTENT_STATISTICS_SUCCESS,
        payload,
      });
      return payload;
    } catch (error) {
      dispatch({
        type: EXPORT_INTENT_STATISTICS_ERROR,
        error,
      });
      throw error;
    }
  };
};
